<template>
    <div class="mainContent settingsPage">

        <transition-group  name="fadeCustom" tag="div" class="wrapper messagesWrapper">
            <Messages
                v-if="messages.length"
                v-for="(message, index) in messages"
                :key="index + 0"
                v-bind="message"
                :i="index"
            />
        </transition-group>

        <div v-if="$mq=='lg'" class="titleWrap mainPageTitle">
            <h2 @click="toggleTab('pay')" :class="{ 'active' : paymentMethodsActive }">{{'pages/settings/index.payment-methods' | trans}}</h2>
            <h2 @click="toggleTab('addr')" :class="{ 'active' : addressBookActive }">{{'pages/settings/index.address-settings' | trans}}</h2>
        </div>
        <div v-if="$mq=='lg' && accountSettingsActive" class="infoWrap accountSettings">
            <PersonalInfo />
        </div>
        <div v-if="$mq=='lg' && paymentMethodsActive" class="infoWrap paymentMethods">
            <YourCards />
            <AddNewCard v-if="$mq=='lg'" />
        </div>

        <div v-if="$mq=='lg' && addressBookActive" class="addressBook">
            <AddressBook />
        </div>

        <ProfilePreview v-if="$mq=='sm'" />
        <NavigationMobile v-if="$mq=='sm'" />

    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import PersonalInfo from '../../components/Settings/PersonalInfo';
    import AddressBook from '../../components/Settings/AddressBook';
    import AddNewCard from '../../components/Settings/AddNewCard';
    import YourCards from '../../components/Settings/YourCards';
    import ProfilePreview from '../../components/Settings/ProfilePreview';
    import NavigationMobile from '../../components/Settings/NavigationMobile';
    import Messages from '../../components/messages/Message';

    export default {
        data() {
            return {
                accountSettingsActive: false,
                paymentMethodsActive: true,
                addressBookActive: false
            }
        },
        computed: {
            ...mapState(['messages'])
        },
        components: {
            AddressBook,
            AddNewCard,
            ProfilePreview,
            NavigationMobile,
            PersonalInfo,
            YourCards,
            Messages
        },
        methods: {
            toggleTab: function (tab) {
                if (tab === 'acc') {
                    this.accountSettingsActive = true;
                    this.paymentMethodsActive = false;
                    this.addressBookActive = false;
                } else if (tab === 'pay') {
                    this.accountSettingsActive = false;
                    this.paymentMethodsActive = true;
                    this.addressBookActive = false;
                }
                else if (tab === 'addr') {
                    this.addressBookActive = true;
                    this.accountSettingsActive = false;
                    this.paymentMethodsActive = false;
                }
            }
        }
    }
</script>
